var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 6.375H1.5V4.875H5.25V6.375ZM5.25 8.625H1.5V10.125H5.25V8.625ZM15.4425 13.875L12.57 11.0025C11.97 11.3925 11.265 11.625 10.5 11.625C8.43 11.625 6.75 9.945 6.75 7.875C6.75 5.805 8.43 4.125 10.5 4.125C12.57 4.125 14.25 5.805 14.25 7.875C14.25 8.64 14.0175 9.345 13.6275 9.9375L16.5 12.8175L15.4425 13.875ZM12.75 7.875C12.75 6.6375 11.7375 5.625 10.5 5.625C9.2625 5.625 8.25 6.6375 8.25 7.875C8.25 9.1125 9.2625 10.125 10.5 10.125C11.7375 10.125 12.75 9.1125 12.75 7.875ZM1.5 13.875H9V12.375H1.5V13.875Z",
    fill: "#213332"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchText);
export default __webpack_public_path__ + "static/media/search_text.7233fe721533019c49de18585ec288a7.svg";
export { ForwardRef as ReactComponent };